import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  paper: {
    maxWidth: 484,
    width: 'calc(100vw - 44px)',
    position: 'absolute',
    right: 44,
    paddingBottom: 70
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    alignItems: 'center',
    padding: 20
  },
  botaoConfirmar: {
    borderRadius: 6,
    backgroundColor: '#044ada',
    fontFamily: "IBM Plex Sans",
    fontSize: 14,
    fontWeight: 500,
    boxShadow: 'none',
    textTransform: 'none',
    color: 'white',
    border: 'none',
    padding: '0.5rem',
    '&:hover': {
      backgroundColor: '#0430ad'
    }
  },
  titulo: {
    fontFamily: 'IBM Plex Sans',
    color: '#5e6784',
    fontSize: 25,
    fontWeight: 500,
    marginBottom: 30
  },
  subtitulo: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#5e6784',
    marginLeft: 20
  },
  root: {
    border: 'none'
  },
  toolbar: theme.mixins.toolbar,
}));

export default useStyles;
